<!-- <div class="jumbotron">
  <div class="form-row headingfluidtypo">
    <div class="col-md-12">
      <p>NOTICE FOR FIRE CADET POSITION</p>
    </div>
  </div>
  <div class="form-row subheadingfluidtypo">
    <div class="col-md-12">
      <p style="margin-bottom:0.5rem">Academy is temporarily closed at this time. It is scheduled to re-open in 48 hours.  At such time you may apply for the Cadet Academy.  Thank you for your interest in the Fire Cadet Academy.</p>
    </div>
  </div>
</div> -->

<div *ngIf="applicationClosed" class="alert alert-danger" role="alert">Application is currently closed.</div>

<div class="jumbotron">
  <div class="form-row headingfluidtypo">
    <div class="col-md-12">
      <p>NOTICE FOR FIRE CADET POSITION</p>
    </div>
  </div>
  <div class="form-row subheadingfluidtypo">
    <div class="col-md-12">
      <p style="margin-bottom:0.5rem">You are responsible for reading this notice in its entirety before you submit your application.</p>
    </div>
  </div>
</div>


<div class="jumbotron">
<div class="form-row headingfluidtypo">
    <div class="col-md-12">
      <p>Fire Cadet Academy Program</p>
    </div>
  </div>
  <div class="form-row subheadingfluidtypo">
    <div class="col-md-12">
      <p style="margin-bottom:0.5rem">PROGRAM DESCRIPTION</p>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <p>The Fire Cadet Academy is designed to ensure that Cadets become familiar with the operations of the
        Fire Department and to provide leadership training. Cadets will receive significant classroom, field and
        fitness training over the course of the two (2) year program. Cadets will be required to attend the Fire
        Academy two (2) Saturdays per month to participate in classroom training, field training, and fitness
        conditioning
      </p>
      
      <div class="form-row subheadingfluidtypo">
        <div class="col-md-12">
          <p style="margin-bottom:0.5rem">WHAT THE JOB INVOLVES</p>
        </div>
      </div>
      <p>Cadets will be assigned to work in major FDNY bureaus where they will receive hands-on training and
        learn how the bureaus relate to one another in order to provide optimal response to emergencies, as
        well as to enhance their ability to provide service in a number of capacities throughout the Agency.
        Cadets must be willing to commit to a minimum of 20 hours per week and can work up to 34 hours per
        week. Cadets will earn $15.67 per hour. Cadets must work 20 or more hours per week to be eligible to
        receive health benefits.
      </p>
      <p style="margin-bottom: 0;">Cadets who successfully complete the academy will be eligible to take the Firefighter Promotional
        Exam to become a Firefighter. Those who pass the Firefighter Promotional Exam, successfully
        complete the Candidate Physical Ability Test (CPAT), and meet all other eligibility requirements will be
        eligible for appointment to Firefighter. All those appointed as probationary firefighters must
        successfully complete the Fire Academy.
      </p>
    </div>
  </div>
</div>

<div class="jumbotron">
  <div class="form-row subheadingfluidtypo">
    <div class="col-md-12">
      <p style="margin-bottom:0.5rem">ELIGIBILITY REQUIREMENTS</p>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <p>Candidates applying to the Fire Cadet Academy must meet all of the following requirements:</p>
      <ul>
        <li>
          <strong>Education requirement</strong>: Candidates must have (1) graduated from a New York City High
          School and received a High School Diploma or (2) attended and did not graduate from a
          New York City High School but obtained a High School Equivalency Diploma (HSE) or its
          educational equivalent must have approved by the state’s Department of Education.</li>
        <li>
          <strong>Citizenship requirement</strong>: Only United States citizens are eligible to become Fire Cadets.</li>
        <li>
          <strong>Residency requirement</strong>: Candidates who are accepted into the Fire Cadet Academy must
          maintain New York City residency throughout the duration of the Cadet program and will be
          required to establish New York City residency within 90 days of appointment.</li>
        <li>
          <strong>Age requirement</strong>: Candidates must be at least 18 years of age and not above 26 years of
          age on the date their application is submitted.</li>
        <li>
          <strong>Language requirement</strong>: Candidates must clearly understand and be understood in English.</li>
        <li>
          <strong>Physical and other requirements</strong>: Candidates must be physically fit and able to meet the
          medical, psychological, and character requirements of the position of Firefighter.</li>
        <li>
          <strong>Character and Background</strong>: Proof of good character and satisfactory background will be an
          absolute prerequisite to the program. Persons who have received a dishonorable discharge
          from the Armed Forces are not eligible. Persons convicted of certain felonies and/or
          misdemeanors may not be eligible but maybe eligible if they have a certificate of good
          conduct.</li>
      </ul>
    </div>
  </div>
</div>

<div class="jumbotron">
  <div class="form-row subheadingfluidtypo">
    <div class="col-md-12">
      <p style="margin-bottom:0.5rem">How to Apply for the Fire Cadet Academy Program</p>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <p>Complete the online application for the Fire Cadet Program during the designated open application
        period.</p>
    </div>
  </div>
</div>

<div class="jumbotron">
  <div class="form-row subheadingfluidtypo">
    <div class="col-md-12">
      <p style="margin-bottom:0.5rem">Additional qualifications for Appointment to the Fire Cadet Academy</p>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <p>In order to complete the compulsory background investigation, you will need to provide a U.S. Postal
        Money Order in the amount of $88.25 for fingerprint screening. This fee cannot be waived.</p>

      <p>
        At the time of the investigation, you must present originals or certified copies of all required
        documents. This includes, but is not limited to, proof of date and place of birth, proof of any military
        service, and proof of meeting educational requirements. 
      </p>
    </div>
  </div>
</div>

<div *ngIf="!applicationClosed" class="jumbotron">
  <div class="form-row subheadingfluidtypo">
    <div class="col-md-12">
      <p style="margin-bottom:0.5rem">Optional Demographics</p>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
     <strong>Ethnicity: (Optional)</strong>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-xl-5 col-lg-5 col-md-5 col-sm-6 col-xs-6" >
      <label for="ethnicity" style="line-height: 0.5em;">
        <strong>Are You:</strong> 
      </label>
      <select  class="custom-select" (change)="onRaceChange($event)" id="ethnicity">
        <option [ngValue]="undefined" selected>Select</option>
        <option value="White">White</option>
        <option value="Black or African">Black or African</option>
        <option value="Asian">Asian</option>
        <option value="Native Hawaiian or Other Pacific Islander">Native Hawaiian or Other Pacific Islander</option>
        <option value="American Indian or Alaska Native">American Indian or Alaska Native</option>
        <option value="Two or more races">Two or more races</option>
        <option value="Unknown/Unspecified">Unknown/Unspecified</option>
        <option value="I choose not to disclose">I choose not to disclose</option>
      </select>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-6" >
      <label for="gender" style="line-height: 0.5em;">
        <strong>Are you Hispanic-Latino?</strong>
      </label>
      <select  class="custom-select" (change)="onHispanicChange($event)" id="gender">
        <option [ngValue]="undefined" selected>Select</option>
        <option value="Yes">Yes</option>
        <option value="No">No</option>
        <option value="I choose not to disclose">I choose not to disclose</option>
      </select>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-xl-5 col-lg-5 col-md-5 col-sm-6 col-xs-6">
      <label for="gender" style="line-height: 0.5em;">
        <strong>Gender(Optional)</strong>
      </label>
      <select class="custom-select" (change)="onGenderChange($event)" id="gender">
        <option [ngValue]="undefined" selected>Select</option>
        <option value="Female or woman">Female or woman</option>
        <option value="Male or man">Male or man</option>
        <option value="Non-binary (not female/woman or male/man)">Non-binary (not female/woman or male/man)</option>
        <option value="Other - a gender not listed above">Other - a gender not listed above</option>
        <option value="Unknown/I choose not to disclose">Unknown/I choose not to disclose</option>
      </select>
    </div>
  </div>
</div>



<div *ngIf="!applicationClosed" class="jumbotron">
  <div class="form-row subheadingfluidtypo">
    <div class="col-md-12">
      <p style="margin-bottom:0.5rem">ACKNOWLEDGEMENT</p>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <p>Before you proceed to fill the application form for the Fire Cadet Academy program, please indicate your acknowledgement
        below.
      </p>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" [(ngModel)]="disableButton1">
        <label class="form-check-label" for="defaultCheck1">
          I am a graduate from a New York City High School 
          <strong>OR</strong> I have obtained a High School
          Equivalency Diploma (HSE) or its educational equivalent approved by a state’s Department
          of Education, after attending a New York City High School.
        </label>
      </div>

      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="" id="defaultCheck2" [(ngModel)]="disableButton2">
        <label class="form-check-label" for="defaultCheck2">
          I am a US Citizen and at least 18 years of age and not above 26 years of age on the date I
submit my application.
        </label>
      </div>

      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="" id="defaultCheck3" [(ngModel)]="disableButton3">
        <label class="form-check-label" for="defaultCheck3">
          I have read the information above and confirm that I understand and meet all the Cadet
          program requirements. 
        </label>
      </div>
      <div class="buttonsm">
        <button type="submit" class="btn btn-primary" [disabled]="!(disableButton1 && disableButton2 && disableButton3 )" (click)=goToCadetAppForm()>Proceed to Application Form</button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/cadethomepage/cadethomepage.component.html